import React, { useEffect } from "react";
import SEO from "../components/SEO";
import FAQ from "../components/FAQ";

const termsList = [
  'Your trading account has a "Unique Client Code" (UCC), different from your demat account number. Do not allow anyone (including your own stock broker, their representatives and dealers) to trade in your trading account on their own without taking specific instruction from you for your trades. Do not share your internet mobile trading login credentials with anyone else.',
  "You are required to place collaterals as margins with the stock broker before you trade. The collateral can either be in the form of funds transfer into specified stock broker bank accounts or margin pledge of securities from your demat account. The bank accounts are listed on the stock broker website. Please do not transfer funds into any other account. The stock broker is not permitted to accept any cash from you.",
  "The stock broker's Risk Management Policy provides details about how the trading limits will be given to you, and the tariff sheet provides the charges that the stock broker will levy on you.",
  "All securities purchased by you will be transferred to your demat account within one working day of the payout. In case of securities purchased but not fully paid by you, the transfer of the same may be subject to limited period pledge i.e. seven trading days after the pay-out (CUSPA pledge) created in favor of the stock broker. You can view your demat account balances directly at the website of the Depositories after creating a login.",
  "The stock broker is obligated to deposit all funds received from you with any of the Clearing Corporations duly allocated in your name. The stock broker is further mandated to return excess funds as per applicable norms to you at the time of quarterly/ monthly settlement. You can view the amounts allocated to you directly at the website of the Clearing Corporation(s).",
  "You will get a contract note from the stock broker within 24 hours of the trade.",
  "You may give a one-time Demat Debit and Pledge Instruction (DDPT) authority to your stock broker for limited access to your demat account, including transferring securities, which are sold in your account for pay-in.",
  "The stock broker is expected to know your financial status and monitor your accounts accordingly. Do share all financial information (e.g. income, networth, etc.) with the stock broker as and when requested for. Kindly also keep your email Id and mobile phone details with the stock broker always updated.",
  "In case of disputes with the stock broker, you can raise a grievance on the dedicated investor grievance ID of the stock broker. You can also approach the stock exchanges and/or SEBI directly.",
  "Any assured/guaranteed/fixed returns schemes or any other schemes of similar nature are prohibited by law. You will not have any protection/recourse from SEBI/stock exchanges for participation in such schemes.",
];

const TermsAndConditions = () => {
  useEffect(() => {
    // Initialize jQuery-based functionality
    if (window.jQuery) {
      const $ = window.jQuery;
      if ($.fn.tab) {
        $(".tab1").tab();
        $(".tab2").tab({ trigger_event_type: "mouseover" });
      }
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-content">
      <SEO
        title="Terms and Conditions (MITC)"
        description="Most Important Terms and Conditions (MITC) for Gateway Financial clients. Understand your rights, obligations, and security protocols for trading and demat accounts."
      />
      <section id="banner-slider" className="inn-banner-slider">
        <div
          id="carouselExampleIndicators"
          className="carousel slide"
          data-ride="carousel"
        >
          <div className="carousel-inner" role="listbox">
            <div
              className="carousel-item active"
              style={{ backgroundImage: "url('/images/other-banner.png')" }}
            >
              <canvas id="canvas"></canvas>
              <div className="carousel-caption">
                <h1>Terms and Conditions</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="welcome-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <h3>Most Important Terms and Conditions (MITC)</h3>
              {termsList.map((term, index) => (
                <p key={index}>
                  <b>{index + 1}.</b> {term}
                </p>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section id="app-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <h3>Download our Investment Fund App</h3>
              <p>Investing With Gateway Financial Services Limited</p>
              <a href="#download" className="lm-btn">
                download &amp; explore more
              </a>
            </div>
            <div className="col-lg-6">
              <img src="images/app-pic.jpg" className="img-fluid" alt="App" />
            </div>
          </div>
        </div>
      </section>

      <FAQ />
    </div>
  );
};

export default TermsAndConditions;
